// PLA-1077: pasos del asistente del analisis fisico en la compra de lotes.
// Los valores tienen que coincidir con las constantes STEP_* de PhysicalAnalysis (Ruby).
export const STEP_DRAFT = 0;
export const STEP_BASIS = 1; // almendra, malla 0, malla 12
export const STEP_DEFECTS = 2; // defectos y densidad
export const STEP_SIEVES = 3; // malla 14, malla 15-18
// Cierre: los tres pasos anteriores piden SOLO sus campos; recien aca se ven todos, se
// escriben las observaciones y se decide aceptar o rechazar.
export const STEP_COMPLETED = 4;

// PLA-1077 v1.1: ripio y caracol son la misma medicion que la malla 0 y la malla 12. El
// asistente no los pide y el servidor los guarda en 0. Tiene que coincidir con
// PhysicalAnalysis::HIDDEN_FIELDS (Ruby).
export const HIDDEN_FIELDS = ['ripio', 'caracol'];

export const COMMIT_DRAFT = 'draft';
export const COMMIT_CONFIRM = 'confirm';

// A que paso pertenece cada campo del formulario.
export const FIELD_STEP: { [field: string]: number } = {
  green: STEP_BASIS,
  sieve_0: STEP_BASIS,
  sieve_12: STEP_BASIS,

  group_1: STEP_DEFECTS,
  group_2: STEP_DEFECTS,
  broca: STEP_DEFECTS,
  paloteo: STEP_DEFECTS,
  ripio: STEP_DEFECTS,
  guayabas: STEP_DEFECTS,
  caracol: STEP_DEFECTS,
  density: STEP_DEFECTS,

  sieve_14: STEP_SIEVES,
  sieve_15: STEP_SIEVES,

  observations: STEP_COMPLETED,
};
